<a [routerLink]="'storefinder'" class="locationFinder" target="_blank">
    <img src="/icons/location-icon-grey.svg" alt="">
</a>